import { useEffect, useState, useCallback, useContext } from 'react'
import { getApi } from '@BUP/services/Axios'
import { ADMIN, ECE } from '@BUP/constants'
import { RoleContext } from '@BUP/contexts/RoleContext'

export const useInboxMessages = () => {
  const role = useContext(RoleContext)

  const [listState, setListState] = useState({
    isLoading: false,
    messages: [],
    error: null
  })

  const roleType = role.type
  const getMessages = useCallback(async () => {
    setListState(prevState => ({
      ...prevState,
      error: null,
      isLoading: true
    }))
    try {
      const client = await getApi('schools', { version: 3 })
      if (roleType === ECE || roleType === ADMIN) {
        const response = await client.get(
          '/current-organization/bup-modes?limit=1000'
        )
        const messages = response.data
        const sortedMessages = messages.sort(
          (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
        )
        setListState(prevState => ({
          ...prevState,
          messages: sortedMessages
        }))
      } else {
        const response = await client.get(
          '/current-enrollment/bup-modes?limit=1000'
        )
        const messages = response.data
        const sortedMessages = messages.sort(
          (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
        )
        setListState(prevState => ({
          ...prevState,
          messages: sortedMessages
        }))
      }
    } catch (e) {
      setListState(prevState => ({
        ...prevState,
        error: e
      }))
    } finally {
      setListState(prevState => ({
        ...prevState,
        isLoading: false
      }))
    }
  }, [roleType, setListState])

  useEffect(() => {
    getMessages()
  }, [getMessages])

  return {
    loading: listState.isLoading,
    data: listState.messages,
    error: listState.error,
    getMessages
  }
}
